  export const isWarning = (fields_to_improve:any,key: string) => {
    return (
      !!fields_to_improve &&
      Object.prototype.hasOwnProperty.call(fields_to_improve, key)
    );
  };